// extracted by mini-css-extract-plugin
export var chevron = "_mb-4";
export var chevronExpanded = "_mb-5";
export var row = "_mb-0";
export var rowBody = "_mb-6";
export var rowDescription = "_mb-7";
export var rowHeader = "_mb-1";
export var rowTitle = "_mb-2";
export var rowTitleComplete = "_mb-3";